export default __webpack_public_path__ + "static/media/default.33ce6246.svg";